var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 137.301,
    height: 137.301,
    viewBox: "0 0 137.301 137.301",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16034",
    "data-name": "Path 16034",
    d: "M144.23,420.82l4.323,12.97A1.764,1.764,0,0,0,150.228,435h6.738a1.761,1.761,0,0,0,1.62-1.065l3.015-7",
    transform: "translate(-144.23 -420.82)",
    fill: "#3fb9eb",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16039",
    "data-name": "Path 16039",
    d: "M247.6,420.82l-4.323,12.97A1.764,1.764,0,0,1,241.6,435h-6.738a1.761,1.761,0,0,1-1.62-1.065l-3.015-7",
    transform: "translate(-230.23 -420.82)",
    fill: "#3fb9eb",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_344",
    "data-name": "Ellipse 344",
    cx: 37.056,
    cy: 33.606,
    rx: 37.056,
    ry: 33.606,
    fill: "#3fb9eb",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16055",
    "data-name": "Path 16055",
    d: "M179.76,431.961l3.768,8.941a1.768,1.768,0,0,0,1.627,1.079h6.851a1.771,1.771,0,0,0,1.62-1.062l4.111-9.5h-.178",
    transform: "translate(-179.76 -431.42)",
    fill: "#3fb9eb",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16059",
    "data-name": "Path 16059",
    d: "M234.345,26.152,223.283,42.09a25.145,25.145,0,0,1-2.11,3.93c-1.164,1.674-4.428,3.348-4.428,3.348s-.29,3.128-1.236,4.22-2.984.438-2.984.438a6.932,6.932,0,0,1-1.82,1.382c-.946.436-3.856-1.164-3.856-1.164a25.293,25.293,0,0,1,2.982,3.784c.364.946,1.02,1.746-.144,2.62s-2.476-.364-2.476-.364.584,1.892-1.09,2.256-3.5-3.276-4.226-4.512-2.838-5.9-3.2-6.114a1.927,1.927,0,0,1-.144-2.474c.728-1.092,5.892-8.078,6.474-8.576s11.72-3.14,11.72-3.14l4.222-11.644",
    transform: "translate(-198.181 -26.08)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16068",
    "data-name": "Path 16068",
    d: "M213.257,124.69a7.023,7.023,0,0,1,1.02,2.476,4.232,4.232,0,0,1-.656,2.838,9.209,9.209,0,0,0-1.236,2.256c-.364,1.02-.436,2.474-.946,3.2s-.8,1.454-.074,2.11,2.62.582,3.64-1.31,1.674-3.93,2.328-4.658a35.432,35.432,0,0,1,2.766-2.4s5.748-.8,6.84-1.818a12.181,12.181,0,0,0,2.038-3.784",
    transform: "translate(-210.929 -123.6)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MF",
    transform: "translate(-24.07 -58.515)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shield--inject-14",
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 19.841, 85.257)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 55.553,
    cy: 55.553,
    r: 55.553,
    transform: "translate(3.997 3.79)",
    fill: "#e7ecef",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: "3.012 3.012"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_349",
    "data-name": "Ellipse 349",
    cx: 46.494,
    cy: 46.494,
    r: 46.494,
    transform: "translate(13.056 12.849)",
    fill: "#fff",
    stroke: "#f3f5f7",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M4.02,0,8.035,6.959H0Z",
    transform: "translate(0 52.569)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    d: "M.069,0,0,.041",
    transform: "translate(98.55 23.258)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_35",
    "data-name": "Line 35",
    x2: 0.069,
    transform: "translate(98.55 23.3)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_37",
    "data-name": "Line 37",
    x1: 0.124,
    transform: "translate(88.262 23.3)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_48",
    "data-name": "Line 48",
    y2: 0.041,
    transform: "translate(98.619 23.258)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M1.84.913a.92.92,0,1,0-1.3.846L.3,3.778H1.532L1.288,1.759A.92.92,0,0,0,1.84.913Z",
    transform: "translate(120.268 72.297)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    d: "M4.02,0,8.035,6.959H0Z",
    transform: "matrix(0.017, 1, -1, 0.017, 63.995, 0)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    d: "M4.02,6.959,8.035,0H0Z",
    transform: "translate(110.839 52.569)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-169",
    transform: "translate(120.92 130.164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16027",
    "data-name": "Path 16027",
    d: "M361.233,254.492s-8.966-15.736-6.9-19.749,7.355,3.2,7.355,3.2-4.6-14.676-2.068-21.088,6.9,0,7.125,4.538a82.338,82.338,0,0,1-.92,12.276s1.84-16,6.207-11.208-5.517,20.814-5.517,20.814,6.666-3.735,6.435,1.068-8.044,9.073-8.044,9.073",
    transform: "translate(-354.027 -214.153)",
    fill: "#3fb9eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16028",
    "data-name": "Path 16028",
    d: "M368.5,277.637s-8.3-7.74-4.253-11.208,6.17,3.735,6.17,3.735-4.468-22.149,2.765-22.952,1.914,19.214,1.914,19.214,6.17-8.538,5.744-1.59-9.572,12.811-9.572,12.811",
    transform: "translate(-361.218 -240.232)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_150",
    "data-name": "Line 150",
    x1: 5.605,
    y1: 6.075,
    transform: "translate(5.751 29.921)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_151",
    "data-name": "Line 151",
    y1: 17.757,
    x2: 1.518,
    transform: "translate(10.19 18.706)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_152",
    "data-name": "Line 152",
    y1: 6.658,
    x2: 5.022,
    transform: "translate(9.956 28.518)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16029",
    "data-name": "Path 16029",
    d: "M377.668,375.33H362.16l1.552,18.292h12.4Z",
    transform: "translate(-360.447 -341.392)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--piggy-bank--inject-169",
    transform: "translate(47.148 109.54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16030",
    "data-name": "Path 16030",
    d: "M113.95,265.429a76.932,76.932,0,0,0-10.147-4.111c-5.008-1.542-10.918-.13-11.048,1.538s.761.9,1.929,2.713.641,6.036,2.312,9.89,6.677,5.779,6.677,5.779Z",
    transform: "translate(-92.743 -256.844)",
    fill: "#3fb9eb",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16031",
    "data-name": "Path 16031",
    d: "M112.364,271.771s-7.708-4.882-12.2-6.553-4.751.771-4.751.771a3.731,3.731,0,0,1,2.443,3.641c0,2.884,1.442,8.859,4.947,10.092S112.364,271.771,112.364,271.771Z",
    transform: "translate(-94.496 -259.459)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_342",
    "data-name": "Ellipse 342",
    cx: 3.902,
    cy: 4.19,
    rx: 3.902,
    ry: 4.19,
    transform: "translate(66.243 11.319) rotate(-20.8)",
    fill: "#3fb9eb",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16032",
    "data-name": "Path 16032",
    d: "M144.23,420.82l4.323,12.97A1.764,1.764,0,0,0,150.228,435h6.738a1.761,1.761,0,0,0,1.62-1.065l3.015-7",
    transform: "translate(-126.592 -362.141)",
    fill: "#3fb9eb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6752",
    "data-name": "Group 6752",
    transform: "translate(17.638 58.679)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16033",
    "data-name": "Path 16033",
    d: "M150.56,420.82l3.576,12.97A1.518,1.518,0,0,0,155.527,435h5.587a1.477,1.477,0,0,0,1.343-1.065l2.5-7",
    transform: "translate(-148.392 -420.82)",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_16035",
    "data-name": "Path 16035",
    d: "M144.23,420.82l4.323,12.97A1.764,1.764,0,0,0,150.228,435h6.738a1.761,1.761,0,0,0,1.62-1.065l3.015-7",
    transform: "translate(-126.592 -362.141)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16036",
    "data-name": "Path 16036",
    d: "M205.831,420.82l-4.32,12.97A1.764,1.764,0,0,1,199.836,435H193.1a1.761,1.761,0,0,1-1.62-1.065l-3.015-7",
    transform: "translate(-155.677 -362.141)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16037",
    "data-name": "Path 16037",
    d: "M247.6,420.82l-4.323,12.97A1.764,1.764,0,0,1,241.6,435h-6.738a1.761,1.761,0,0,1-1.62-1.065l-3.015-7",
    transform: "translate(-183.131 -362.141)",
    fill: "#3fb9eb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6753",
    "data-name": "Group 6753",
    transform: "translate(47.099 58.679)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16038",
    "data-name": "Path 16038",
    d: "M247.669,420.82l-2.956,12.97c-.164.719-.623,1.206-1.144,1.206H238.96c-.48,0-.915-.418-1.106-1.065l-2.864-6.851",
    transform: "translate(-233.359 -420.82)",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_16040",
    "data-name": "Path 16040",
    d: "M247.6,420.82l-4.323,12.97A1.764,1.764,0,0,1,241.6,435h-6.738a1.761,1.761,0,0,1-1.62-1.065l-3.015-7",
    transform: "translate(-183.131 -362.141)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_343",
    "data-name": "Ellipse 343",
    cx: 37.056,
    cy: 33.606,
    rx: 37.056,
    ry: 33.606,
    transform: "translate(4.312)",
    fill: "#3fb9eb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6754",
    "data-name": "Group 6754",
    transform: "translate(4.312)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16041",
    "data-name": "Path 16041",
    d: "M181.976,280.6a30.869,30.869,0,0,1,3.306,13.895c0,18.56-16.591,33.606-37.056,33.606a39.522,39.522,0,0,1-21.5-6.228c6.461,8.67,17.4,14.388,29.8,14.388,19.869,0,35.97-14.6,35.97-32.606A31.192,31.192,0,0,0,181.976,280.6Z",
    transform: "translate(-119.399 -269.956)",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_345",
    "data-name": "Ellipse 345",
    cx: 37.056,
    cy: 33.606,
    rx: 37.056,
    ry: 33.606,
    transform: "translate(4.312)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16042",
    "data-name": "Path 16042",
    d: "M296.009,356.43a30.774,30.774,0,0,1-8.629,17.762",
    transform: "translate(-220.703 -319.809)",
    fill: "none",
    stroke: "#3fb9eb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16043",
    "data-name": "Path 16043",
    d: "M310.78,326a29.508,29.508,0,0,1,.822,6.923",
    transform: "translate(-236.087 -299.804)",
    fill: "none",
    stroke: "#3fb9eb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16044",
    "data-name": "Path 16044",
    d: "M186.68,253.6a40.711,40.711,0,0,1,9.314-1.069,41.168,41.168,0,0,1,6.006.44",
    transform: "translate(-154.5 -251.502)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16045",
    "data-name": "Path 16045",
    d: "M200.3,280.863a9.266,9.266,0,0,0,3.727-6.937c.13-4.495-5.783-11.044-10.534-13.744s-8.222-2.182-8.348-.257-1.8,4.111-2.439,7.835-.9,9.249,4.111,11.048",
    transform: "translate(-151.661 -255.308)",
    fill: "#3fb9eb",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16046",
    "data-name": "Path 16046",
    d: "M194.923,281.618l.737.11c3.158.456,4.268-1.607,4.176-4.7-.127-4.368-5.906-13.617-8.348-14.9s-3.21.514-3.21.514.343.23-.86,4.22c-.555,1.843-2.621,8.27-.576,11.12C188.651,280.494,192.011,281.183,194.923,281.618Z",
    transform: "translate(-154.025 -257.504)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16047",
    "data-name": "Path 16047",
    d: "M231.475,286.3h-.048a.343.343,0,0,1-.295-.387,6.85,6.85,0,0,0,.065-.795c.069-2.4-1.888-5.841-5.1-9.016a.344.344,0,1,1,.483-.49c3.4,3.357,5.382,6.916,5.306,9.523a8.2,8.2,0,0,1-.069.87A.343.343,0,0,1,231.475,286.3Z",
    transform: "translate(-180.344 -266.611)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16048",
    "data-name": "Path 16048",
    d: "M235.96,313.146a.343.343,0,0,1-.267-.558,8.42,8.42,0,0,0,1.336-2.3.343.343,0,0,1,.641.243,9.064,9.064,0,0,1-1.446,2.491A.343.343,0,0,1,235.96,313.146Z",
    transform: "translate(-186.672 -289.327)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_346",
    "data-name": "Ellipse 346",
    cx: 7.578,
    cy: 10.02,
    rx: 7.578,
    ry: 10.02,
    transform: "translate(3.062 42.609) rotate(-75.99)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_347",
    "data-name": "Ellipse 347",
    cx: 7.578,
    cy: 10.02,
    rx: 7.578,
    ry: 10.02,
    transform: "translate(2.58 41.872) rotate(-75.99)",
    fill: "#3fb9eb",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16049",
    "data-name": "Path 16049",
    d: "M121.682,350.723c.062.918-.291,1.692-.784,1.713s-.949-.685-1.028-1.6.291-1.7.788-1.713S121.62,349.8,121.682,350.723Z",
    transform: "translate(-110.57 -315.003)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16050",
    "data-name": "Path 16050",
    d: "M141.5,355.686c.062.922-.291,1.692-.784,1.713s-.949-.685-1.028-1.607.291-1.692.788-1.713S141.43,354.764,141.5,355.686Z",
    transform: "translate(-123.6 -318.264)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16051",
    "data-name": "Path 16051",
    d: "M145.9,365.72a7.986,7.986,0,0,1-.459,1.929c-1.966,5.313-9.085,7.612-16.118,5.324",
    transform: "translate(-116.79 -325.917)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_153",
    "data-name": "Line 153",
    x2: 2.182,
    transform: "translate(27.959 39.3)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16052",
    "data-name": "Path 16052",
    d: "M130,318.79c-.24,1-.853,1.713-1.37,1.583s-.743-1.028-.5-2.035.853-1.713,1.37-1.586S130.246,317.79,130,318.79Z",
    transform: "translate(-115.945 -293.714)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_348",
    "data-name": "Ellipse 348",
    cx: 1.864,
    cy: 0.963,
    rx: 1.864,
    ry: 0.963,
    transform: "translate(18.068 27.813) rotate(-76.45)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16053",
    "data-name": "Path 16053",
    d: "M179.76,431.961l3.768,8.941a1.768,1.768,0,0,0,1.627,1.079h6.851a1.771,1.771,0,0,0,1.62-1.062l4.111-9.5h-.178",
    transform: "translate(-149.951 -369.11)",
    fill: "#3fb9eb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6755",
    "data-name": "Group 6755",
    transform: "translate(29.809 62.31)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16054",
    "data-name": "Path 16054",
    d: "M190.055,428.947c-2.172,0-4.7.284-6.745-.188l3.522,10.253a1.483,1.483,0,0,0,1.346,1.079h5.646a1.476,1.476,0,0,0,1.336-1.062l3.409-10.459-1.37.188A38.33,38.33,0,0,1,190.055,428.947Z",
    transform: "translate(-182.094 -429.546)",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_16056",
    "data-name": "Path 16056",
    d: "M179.76,431.961l3.768,8.941a1.768,1.768,0,0,0,1.627,1.079h6.851a1.771,1.771,0,0,0,1.62-1.062l4.111-9.5h-.178",
    transform: "translate(-149.951 -369.11)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Hand--inject-169",
    transform: "translate(80.32 64.377)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16057",
    "data-name": "Path 16057",
    d: "M234.345,26.152,223.283,42.09a25.145,25.145,0,0,1-2.11,3.93c-1.164,1.674-4.428,3.348-4.428,3.348s-.29,3.128-1.236,4.22-2.984.438-2.984.438a6.932,6.932,0,0,1-1.82,1.382c-.946.436-3.856-1.164-3.856-1.164a25.293,25.293,0,0,1,2.982,3.784c.364.946,1.02,1.746-.144,2.62s-2.476-.364-2.476-.364.584,1.892-1.09,2.256-3.5-3.276-4.226-4.512-2.838-5.9-3.2-6.114a1.927,1.927,0,0,1-.144-2.474c.728-1.092,5.892-8.078,6.474-8.576s11.72-3.14,11.72-3.14l4.222-11.644",
    transform: "translate(-193.745 -26.08)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6756",
    "data-name": "Group 6756",
    transform: "translate(4.436)",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16058",
    "data-name": "Path 16058",
    d: "M227.6,80.04s-1.2,3.6-2.5,4.3-8.7,2.6-11.6,2.2a11.216,11.216,0,0,1-4.5-1.5s-1.6,2.1-2.3,2.8a4.586,4.586,0,0,1-1.7,1s3.48,8.742,5.982,11.448a1.2,1.2,0,0,0,.6.028c1.674-.364,1.09-2.256,1.09-2.256s1.31,1.236,2.476.364.508-1.674.144-2.62A25.229,25.229,0,0,0,212.3,92.02s2.91,1.6,3.856,1.164a6.918,6.918,0,0,0,1.82-1.384s2.038.656,2.984-.436,1.236-4.22,1.236-4.22,3.274-1.674,4.44-3.348a24.954,24.954,0,0,0,2.11-3.93L233.3,73.3Z",
    transform: "translate(-203.636 -63.856)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_16060",
    "data-name": "Path 16060",
    d: "M234.345,26.152,223.283,42.09a25.145,25.145,0,0,1-2.11,3.93c-1.164,1.674-4.428,3.348-4.428,3.348s-.29,3.128-1.236,4.22-2.984.438-2.984.438a6.932,6.932,0,0,1-1.82,1.382c-.946.436-3.856-1.164-3.856-1.164a25.293,25.293,0,0,1,2.982,3.784c.364.946,1.02,1.746-.144,2.62s-2.476-.364-2.476-.364.584,1.892-1.09,2.256-3.5-3.276-4.226-4.512-2.838-5.9-3.2-6.114a1.927,1.927,0,0,1-.144-2.474c.728-1.092,5.892-8.078,6.474-8.576s11.72-3.14,11.72-3.14l4.222-11.644",
    transform: "translate(-193.745 -26.08)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16061",
    "data-name": "Path 16061",
    d: "M189.83,190.908l.29,1.092,4.512-1.092,4.222-11.062-2.766-.946Z",
    transform: "translate(-187.064 -148.336)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16062",
    "data-name": "Path 16062",
    d: "M180.148,165.44l6.258,2.33L183.35,181.6,176,179.34Z",
    transform: "translate(-176 -137.568)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16063",
    "data-name": "Path 16063",
    d: "M177.23,181.938l6.522,1.918,2.838-12.3-5.714-1.836Z",
    transform: "translate(-176.984 -140.992)",
    fill: "#3fb9eb",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16064",
    "data-name": "Path 16064",
    d: "M185.034,184.655a2.062,2.062,0,0,0-.87-.04l-1.7,5.71a2.042,2.042,0,0,0,.882.506c1.336.368,2.8-.718,3.268-2.424S186.368,185.021,185.034,184.655Z",
    transform: "translate(-181.168 -152.885)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16066",
    "data-name": "Path 16066",
    d: "M213.257,124.69a7.023,7.023,0,0,1,1.02,2.476,4.232,4.232,0,0,1-.656,2.838,9.209,9.209,0,0,0-1.236,2.256c-.364,1.02-.436,2.474-.946,3.2s-.8,1.454-.074,2.11,2.62.582,3.64-1.31,1.674-3.93,2.328-4.658a35.432,35.432,0,0,1,2.766-2.4s5.748-.8,6.84-1.818a12.181,12.181,0,0,0,2.038-3.784",
    transform: "translate(-203.943 -104.096)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6757",
    "data-name": "Group 6757",
    transform: "translate(6.986 19.504)",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16067",
    "data-name": "Path 16067",
    d: "M228.543,128.5a23.353,23.353,0,0,1-5.5,2.6c-2.4.6-3.9.6-4.8,1.8s-1.8,5-3,5.7-1.4-1.8-3.1-1.3l-.056.02a6.2,6.2,0,0,1-.648,2.062c-.51.728-.8,1.454-.074,2.11s2.62.582,3.64-1.31,1.674-3.93,2.328-4.658a35.429,35.429,0,0,1,2.766-2.4s5.748-.8,6.84-1.818a8.967,8.967,0,0,0,1.642-2.764Z",
    transform: "translate(-210.929 -127.52)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_16069",
    "data-name": "Path 16069",
    d: "M213.257,124.69a7.023,7.023,0,0,1,1.02,2.476,4.232,4.232,0,0,1-.656,2.838,9.209,9.209,0,0,0-1.236,2.256c-.364,1.02-.436,2.474-.946,3.2s-.8,1.454-.074,2.11,2.62.582,3.64-1.31,1.674-3.93,2.328-4.658a35.432,35.432,0,0,1,2.766-2.4s5.748-.8,6.84-1.818a12.181,12.181,0,0,0,2.038-3.784",
    transform: "translate(-203.943 -104.096)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16070",
    "data-name": "Path 16070",
    d: "M211.29,146.666s1.894,1.018,3.276-.146",
    transform: "translate(-204.232 -122.432)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_154",
    "data-name": "Line 154",
    x1: 1.672,
    y1: 3.202,
    transform: "translate(11.79 31.002)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16071",
    "data-name": "Path 16071",
    d: "M269.88,151.834a4.421,4.421,0,0,0,1.236-3.494",
    transform: "translate(-251.104 -123.888)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-169",
    transform: "translate(56.184 182.394)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16072",
    "data-name": "Path 16072",
    d: "M2,0H88.047",
    transform: "translate(-2)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMf);
export default __webpack_public_path__ + "static/media/MF.7b51f72300c6e3b07696b4d3fd5cab45.svg";
export { ForwardRef as ReactComponent };